import { inject, InjectionToken } from '@angular/core';

import { map, Observable, shareReplay } from 'rxjs';

import { SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';

import { BAZIS_WINDOW_SIZES } from './window-sizes.token';

export enum Breakpoints {
    xxl = 'xxl',
    xl = 'xl',
    lg = 'lg',
    md = 'md',
    sm = 'sm',
    xs = 'xs',
}

export enum Dimensions {
    xxl = 1200,
    xl = 1024,
    lg = 992,
    md = 768,
    sm = 576,
    xs = 0,
}

function detectBreakpoint(width: number): Breakpoints {
    if (width >= Dimensions.xxl) return Breakpoints.xxl;
    if (width >= Dimensions.xl) return Breakpoints.xl;
    if (width >= Dimensions.lg) return Breakpoints.lg;
    if (width >= Dimensions.md) return Breakpoints.md;
    if (width >= Dimensions.sm) return Breakpoints.sm;
    return Breakpoints.xs;
}

export const BAZIS_BREAKPOINT = new InjectionToken<Observable<Breakpoints>>('BAZIS_BREAKPOINT', {
    providedIn: 'root',
    factory: () =>
        inject(BAZIS_WINDOW_SIZES).pipe(
            map(({ width }) => detectBreakpoint(width)),
            shareReplay(SHARE_REPLAY_SETTINGS),
        ),
});
